import React from 'react';
import { SERVICE_VIEWS } from './ServiceConstants';
import { stringReplace } from '../../utils/core';
import translations from '../../translations';
import '../../typedefs/service';

/**
 * A view which asks the user first, before progressing to deleting a Service
 * @param {ServiceData} serviceData - information about the service being deleted e.g. name, id etc.
 * @param {Function} switchView - function to change the view of the service controller
 * @param {Function} deleteService - function to continue and delete the service
 */
const ServiceDelete = ({ serviceData, switchView, deleteService }) => (
    <div className="full-height flex-column">
        <div className="admin-page main-scroller">
            <h1>Confirm Delete</h1>
            <span>
                {stringReplace(translations.SC_delete_service_1, serviceData.developerName)}
                <span className="bold margin-left-sml">{translations.GENERAL_cannot_be_undone}</span>
            </span>
        </div>
        <div className="mw-footer container-fluid">
            <button
                type="button"
                className="btn btn-default outcome"
                onClick={() => switchView(SERVICE_VIEWS.ServiceList)}
            >
                {'Cancel'}
            </button>
            <button
                type="button"
                className="btn btn-primary outcome"
                onClick={() => deleteService(serviceData)}
            >
                {'Delete'}
            </button>
        </div>
    </div>
);

export default ServiceDelete;
